app.factory("Language", ["$http", "$log",
    function ($http, $log) {
        var Languages = {};

        Languages.containersList = function () {
            return $http.get("/language/container/list").then(function (resp) {
                return resp.data;
            });
        };

        Languages.copyToProgram = function (params) {
            return $http.post("/language/copy", {
                program: params.program,
                containers: params.containers
            }).then(function (resp) {
                return resp.data;
            });
        };

        Languages.createContainer = function (params) {
            return $http.post("/language/container/add", {
                name: params.name,
                required: params.required
            }).then(function (resp) {
                return resp.data;
            });
        };

        Languages.fetchContainer = function (params) {
            return $http.get("/language/container/one/" + params.containerId).then(function (resp) {
                return resp.data;
            });
        };

        Languages.updateContainer = function (params) {
            return $http.post("/language/container/update", {
                "_id": params._id,
                "name": params.name
            }).then(function (resp) {
                return resp.data;
            });
        };

        Languages.removeContainer = function (params) {
            return $http.post("/language/container/remove", {
                "containerId": params.containerId
            }).then(function (resp) {
                return resp.data;
            });
        };

        Languages.createSubjectWrapper = function (params) {
            return $http.post("/language/subject/add", {
                subject: params.subjectId,
                lecturer: params.lecturerId,
                container: params.containerId,
                season: params.season,
                semester: params.semester,
                credits: params.credits,
                preCredits: params.preCredits,
                name: params.name,
                program: params.program,
                prerequisites: params.prerequisites
            }).then(function (resp) {
                return resp.data;
            });
        };

        Languages.editSubjectWrapper = function (params) {
            return $http.post("/language/subject/update", {
                _id: params._id,
                subject: params.subjectId,
                lecturer: params.lecturerId,
                container: params.containerId,
                season: params.season,
                semester: params.semester,
                program: params.program,
                credits: params.credits,
                preCredits: params.preCredits,
                prerequisites: params.prerequisites
            }).then(function (resp) {
                return resp.data;
            });
        };

        Languages.deleteSubjectWrapper = function (params) {
            return $http.post("/language/subject/remove", {
                "subjectWrapperId": params.wrapperId
            }).then(function (resp) {
                return resp.data;
            });
        };

        return Languages;
    }
])
;